class Newsletter {
  constructor(args) {
    const { formId } = args;

    this.formId = formId;
    this.form = document.getElementById(formId);
    this.emailField = document.getElementById(`${formId}-email`);

    this.messageField = document.getElementById(`${formId}-message`);
    this.submitButton = document.getElementById(`${formId}-submit`);

    if (formId === 'mailchimp-sidebar') {
      this.initializeSidebar();
    } else {
      this.initializeForm();
    }
  }

  initializeForm() {
    this.form.addEventListener('submit', event => {
      const email = this.emailField.value;
      const formUrl = `/wp-admin/admin-ajax.php?action=mailchimpsubscribe&email=${email}`;

      event.preventDefault();
      const request = new XMLHttpRequest();

      request.open('POST', formUrl, true);
      request.setRequestHeader('Content-Type', 'application/json');
      request.onreadystatechange = function() {
        if (request.readyState === 4 && request.status === 200) {
          window.location = `/newsletter?email=${email}`;
        }
      };

      request.send();
      this.submitButton.classList.add('visually-hidden');
      this.emailField.classList.add('visually-hidden');
      this.messageField.classList.remove('visually-hidden');
    });
  }

  initializeSidebar() {
    this.form.addEventListener('submit', event => {
      const fname_field = document.getElementById(`${this.formId}-name-first`);
      const lname_field = document.getElementById(`${this.formId}-name-last`);

      const fname = fname_field.value;
      const lname = lname_field.value;

      const initiative = document.getElementById(`${this.formId}-initiative`).value;

      const email = this.emailField.value;

      event.preventDefault();

      fname_field.removeAttribute('aria-invalid');
      fname_field.classList.remove('get-involved__input-error');
      lname_field.removeAttribute('aria-invalid');
      lname_field.classList.remove('get-involved__input-error');
      this.emailField.removeAttribute('aria-invalid');
      this.emailField.classList.remove('get-involved__input-error');

      if (!fname || !lname || !email) {
        if (!fname) {
          fname_field.setAttribute('aria-invalid', true);
          fname_field.classList.add('get-involved__input-error');
        }
        if (!lname) {
          lname_field.setAttribute('aria-invalid', true);
          lname_field.classList.add('get-involved__input-error');
        }
        if (!email) {
          this.emailField.setAttribute('aria-invalid', true);
          this.emailField.classList.add('get-involved__input-error');
        }
        return;
      }

      const params = `email=${email}&fname=${fname}&lname=${lname}&initiative=${initiative}`;
      const formUrl = `/wp-admin/admin-ajax.php?action=mailchimpgetinvolved&${params}`;

      const request = new XMLHttpRequest();

      request.open('POST', formUrl, true);
      request.setRequestHeader('Content-Type', 'application/json');
      request.onreadystatechange = function() {
        if (request.readyState === 4 && request.status === 200) {
          window.location = `/get-involved?${params}`;
        }
      };

      request.send();
      this.form.classList.add('visually-hidden');
      document.getElementById('mailchimp-sidebar-message').classList.remove('visually-hidden');
    });
  }
}

export default Newsletter;
